import { render, staticRenderFns } from "./ImagePuzzleSliderCaptcha.vue?vue&type=template&id=fe212ebe&scoped=true&"
import script from "./ImagePuzzleSliderCaptcha.vue?vue&type=script&lang=js&"
export * from "./ImagePuzzleSliderCaptcha.vue?vue&type=script&lang=js&"
import style0 from "./ImagePuzzleSliderCaptcha.vue?vue&type=style&index=0&id=fe212ebe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe212ebe",
  null
  
)

export default component.exports